import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_ds_account_contact_lookupService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { accounts?: string[] }): 
  Promise<{ result: { Id?: number, Name?: string, AccountsContactsLookup?: { AccountId?: number, Contact?: { Id?: number, AddressId?: number } }[] }[] }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { accounts?: string[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Name?: string, AccountsContactsLookup?: { AccountId?: number, Contact?: { Id?: number, AddressId?: number } }[] }[], totalCount: number }> 
  {
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { accounts?: string[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Name?: string, AccountsContactsLookup?: { AccountId?: number, Contact?: { Id?: number, AddressId?: number } }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      accounts?: string[]    }) {
      return false;
    }
}
